import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'economy-';

export default {
    path: '/economy',
    name: 'economy',
    redirect: {
        name: `${pre}economy`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'enterprise',
            name: `${pre}enterprise`,
            meta: {
                ...meta,
                title: '企业',
                closable: false
            },
            component: () => import('@/pages/economy/enterprise')
        },{
            path: 'manifest/:type',
            name: `${pre}manifest`,
            meta: {
                ...meta,
                title: '货单',
                closable: false
            },
            props: true,
            component: () => import('@/pages/economy/manifest')
        }
        ,{
            path: 'supplier',
            name: `${pre}supplier`,
            meta: {
                ...meta,
                title: '个体户',
                closable: false
            },
            component: () => import('@/pages/economy/supplier')
        }
        ,{
            path: 'agreement',
            name: `${pre}agreement`,
            meta: {
                ...meta,
                title: '合同管理',
                closable: false
            },
            component: () => import('@/pages/economy/agreement')
        },{
            path: 'contract/:type',
            name: `${pre}contract`,
            meta: {
                ...meta,
                title: '合同管理',
                closable: false
            },
            props: true,
            component: () => import('@/pages/economy/contract')
        },{
            path: 'tax-bill',
            name: `${pre}tax-bill`,
            meta: {
                ...meta,
                title: '税务管理',
                closable: false
            },
            component: () => import('@/pages/economy/tax-bill')
        }
        ,{
            path: 'invoice-content',
            name: `${pre}invoice-content`,
            meta: {
                ...meta,
                title: '开票内容',
                closable: false
            },
            component: () => import('@/pages/economy/invoice-content')
        }
        ,{
            path: 'invoice/:type',
            name: `${pre}invoice`,
            meta: {
                ...meta,
                title: '发票',
                closable: false
            },
            props: true,
            component: () => import('@/pages/economy/invoice')
        }
        /*,{
            path: 'manifest-record',
            name: `${pre}manifest-record`,
            meta: {
                ...meta,
                title: '货单记录',
                closable: false
            },
            component: () => import('@/pages/economy/manifest-record')
        }*/
        ,{
            path: 'manifest/:invoicing',
            name: `${pre}manifest`,
            meta: {
                ...meta,
                title: '货单',
                closable: false
            },
            props: true,
            component: () => import('@/pages/economy/manifest')
        }
        ,{
            path: 'module-content',
            name: `${pre}module-content`,
            meta: {
                ...meta,
                title: '模块内容',
                closable: false
            },
            component: () => import('@/pages/economy/module-content')
        }
        ,{
            path: 'feedback',
            name: `${pre}feedback`,
            meta: {
                ...meta,
                title: '问题反馈',
                closable: false
            },
            component: () => import('@/pages/economy/feedback')
        }
        ,{
            path: 'module-table',
            name: `${pre}module-table`,
            meta: {
                ...meta,
                title: '模块管理',
                closable: false
            },
            component: () => import('@/pages/economy/module-table')
        }
        ,{
            path: 'ban-card',
            name: `${pre}ban-card`,
            meta: {
                ...meta,
                title: '银行卡管理',
                closable: false
            },
            component: () => import('@/pages/economy/ban-card')
        }
        ,{
            path: 'pay',
            name: `${pre}pay`,
            meta: {
                ...meta,
                title: '支付管理',
                closable: false
            },
            component: () => import('@/pages/economy/pay')
        }
        ,{
            path: 'article-table',
            name: `${pre}article-table`,
            meta: {
                ...meta,
                title: '文章管理',
                closable: false
            },
            component: () => import('@/pages/economy/article-table')
        }
        ,{
            path: 'column-table',
            name: `${pre}column-table`,
            meta: {
                ...meta,
                title: '栏目管理',
                closable: false
            },
            component: () => import('@/pages/economy/column-table')
        }
        ,{
            path: 'extend-field',
            name: `${pre}extend-field`,
            meta: {
                ...meta,
                title: '扩展字段',
                closable: false
            },
            component: () => import('@/pages/economy/extend-field')
        }
        ,{
            path: 'banner',
            name: `${pre}banner`,
            meta: {
                ...meta,
                title: '轮播图管理',
                closable: false
            },
            component: () => import('@/pages/economy/banner')
        },
        {
            path: 'tax-warn',
            name: `${pre}tax-warn`,
            meta: {
                ...meta,
                title: '税务预警',
                closable: false
            },
            component: () => import('@/pages/economy/tax-warn')
        },
        {
            path: 'industry-commerce-warn',
            name: `${pre}industry-commerce-warn`,
            meta: {
                ...meta,
                title: '工商预警',
                closable: false
            },
            component: () => import('@/pages/economy/industry-commerce-warn')
        },
        {
            path: 'capital-warn',
            name: `${pre}capital-warn`,
            meta: {
                ...meta,
                title: '资金预警',
                closable: false
            },
            component: () => import('@/pages/economy/capital-warn')
        },{
            path: 'income-expenses-data',
            name: `${pre}income-expenses-data`,
            meta: {
                ...meta,
                title: '资金流水管理',
                closable: false
            },
            component: () => import('@/pages/economy/income-expenses-data')
        },{
            path: 'invoice-month',
            name: `${pre}invoice-month`,
            meta: {
                ...meta,
                title: '货物进销存管理',
                closable: false
            },
            component: () => import('@/pages/economy/invoice-month')
        },{
            path: 'pay-limit',
            name: `${pre}pay-limit`,
            meta: {
                ...meta,
                title: '限额管理',
                closable: false
            },
            component: () => import('@/pages/economy/pay-limit')
        },{
            path: 'waste-materials',
            name: `${pre}waste-materials`,
            meta: {
                ...meta,
                title: '废旧物资分类管理',
                closable: false
            },
            component: () => import('@/pages/economy/waste-materials')
        },
        {
            path: 'adress',
            name: `${pre}adress`,
            meta: {
                ...meta,
                title: '收货管理',
                closable: false
            },
            component: () => import('@/pages/economy/adress')
        },
        {
            path: 'camera-config',
            name: `${pre}camera-config`,
            meta: {
                ...meta,
                title: '摄像头配置管理',
                closable: false
            },
            component: () => import('@/pages/economy/camera-config')
        },
        {
            path: 'enterprise-directory',
            name: `${pre}enterprise-directory`,
            meta: {
                ...meta,
                title: '企业目录管理',
                closable: false
            },
            component: () => import('@/pages/economy/enterprise-directory')
        },
        {
            path: 'supplier-audit',
            name: `${pre}supplier-audit`,
            meta: {
                ...meta,
                title: '个体户审核',
                closable: false
            },
            component: () => import('@/pages/economy/supplier-audit')
        },
        {
            path: 'enterprise-directory-detail',
            name: `${pre}enterprise-directory-detail`,
            meta: {
                ...meta,
                title: '企业目录详情',
                closable: false
            },
            component: () => import('@/pages/economy/enterprise-directory/enterprise-directory-table-details')
        },
        {
            path: 'invoice-details',
            name: `${pre}invoice-details`,
            meta: {
                ...meta,
                title: '票据明细',
                closable: false
            },
            component: () => import('@/pages/economy/invoice-details')
        },
        {
            path: 'invoice-audit',
            name: `${pre}invoice-audit`,
            meta: {
                ...meta,
                title: '开票审核',
                closable: false
            },
            component: () => import('@/pages/economy/invoice-audit')
        },
    ]
};
